import type { ComponentProps } from "react";

import { DefinedDefaults } from "@/ui/lib/types";

/*-------------------------------------
|  Constants
|-------------------------------------*/

export const SPINNER_SIZE_CLASS_MAP = {
  3: "size-3",
  4: "size-4",
  5: "size-5",
  6: "size-6",
  8: "size-8",
} as const;

/*-------------------------------------
|  Types
|-------------------------------------*/

export type TSpinnerSize = keyof typeof SPINNER_SIZE_CLASS_MAP;

export type TSpinnerProps = {
  size?: TSpinnerSize;
} & Omit<ComponentProps<"svg">, "size">;

type TSpinnerDefaultProps = DefinedDefaults<TSpinnerProps, "size">;

/*-------------------------------------
|  Defaults
|-------------------------------------*/

export const SPINNER_DEFAULTS = {
  size: 4,
} satisfies TSpinnerDefaultProps;
